module.exports = __webpack_public_path__ + "static/img/sl-5.18238c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/sl-5.png
// module id = g7Jh
// module chunks = 0